import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideContentsBlockData from '../../../Models/Content/GenericGuideContentsBlockData';
import GenericGuideContents from './GenericGuideContentsBlock';

export default class GenericGuideContentsBlock extends EpiComponent<GenericGuideContentsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-contents-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideContents iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

